export const normalizeEmployeeIds = (ids = []) =>
  Array.from(
    new Set(
      (Array.isArray(ids) ? ids : [])
        .map((id) => String(id || '').trim())
        .filter(Boolean)
    )
  );

export const getStaffPhotoUrl = (staffMember) =>
  staffMember?.photoURL || staffMember?.photoUrl || '';

export const getStaffRole = (staffMember) =>
  staffMember?.title || (staffMember?.isOwner ? 'Owner' : 'Staff member');
